import React, {useEffect, useState} from 'react';

import ItemsList from './ItemsList';
import Loading from './bits/Loading';
import API from '../apis/cs-api';
import { USERVARS, blackListCleanUp } from '../Common.js';


export default function Edut(props) {

    const [items, setItems] = useState(null)
    const [loading, setLoading] = useState(true)
    const [globalCategories, setGlobalCategories] = useState(null)

    useEffect(() => {

        const handler = evt => {
            setGlobalCategories(evt.detail)
            loadCampaigns([])
        }

        const loadCampaigns = async sArr => {
            let items_amount = (window.BLOCKVARS_ITEMS_PER_PAGE || USERVARS.ITEMS_PER_PAGE)

            //identical to main app
            let fetchUrl ='campaignsf?page=' + Math.floor(Math.random() * ((200/items_amount) - 1) + 1) + '&limit='+items_amount;

            if(sArr[0] && sArr[0] !== '' && sArr[0] !== '*') fetchUrl += '&location='+sArr[0].split(USERVARS.URL_DIVIDER || "+").join(' ');
            if(globalCategories) fetchUrl += '&categories=' + globalCategories
            const response = await API.get(fetchUrl);
            setItems(blackListCleanUp(response.data.kampanjat))
            // searchTerms: this.props.searchTerms,
            setLoading(false)
            fetchUrl = null
        }

        window.addEventListener("globalVarChanged", handler)
        loadCampaigns([])
        return () => {
            window.removeEventListener("globalVarChanged", handler)
        }
    }, [globalCategories])


    if(loading) return <Loading />
    if(items?.length < 1) return null
    return <ItemsList items={items} />
}